<form #lForm="ngForm">
  <div class="md-form">
    <frontend-link-social-icon class="prefix" [link]="link">
    </frontend-link-social-icon>
    <!-- <mdb-icon fab icon="linkedin" class="prefix linkedin-color"></mdb-icon> -->
    <input
      type="text"
      name="url_link"
      id="url_link"
      class="form-control"
      mdbInput
      mdbValidate
      [(ngModel)]="link.url"
      (ngModelChange)="changedInputValue()"
      [placeholder]="'COMMON.PASTE_LINK' | transloco"
      #url_link="ngModel"
      minlength="15"
      >
    <label for="url_link" *transloco="let t">
      @if (link.category == 'social' && link.type !== 'linkedin') {
        <span>{{t('ACCOUNT.PROFILE.MY_PROFILE_ON') +' '+link.type}}</span>
      }
      @if (link.category == 'social' && link.type == 'linkedin') {
        <span *transloco="let t; scope 'profile'">{{t('profile.my_linkedin_profile')}}</span>
      }
      @if (link.category == 'profile') {
        <span>{{t('ACCOUNT.PROFILE.'+linkPivotType)}}</span>
      }
    </label>
    @if (url_link.invalid && url_link.touched) {
      <alert
        [type]="'warning'" [dismissible]="true">
        @if (url_link.errors.minlength) {
          <div>
            <span *transloco="let t">
              <span>{{t('COMMON.TOO_SHORT')}}</span>
            </span>
          </div>
        }
      </alert>
    }
    <!-- <mdb-error *ngIf="url_link.invalid && url_link.touched">
    <div *ngIf="url_link.errors.minlength">
      <span *transloco="let t">
        <span>{{t('COMMON.TOO_SHORT')}}</span>
      </span>
    </div>
  </mdb-error> -->
</div>
</form>